export const translations = {
    'it': {
        'shared.deepening_text': "Se vuoi approfondire i dati di Travel Appeal e AirBnb presentati da IDD abbiamo preparato una sezione che illustra il metodo di raccolta e analisi dei dati. ",
        'shared.deepening_link': "Scopri di più sui dati di IDD",
        'accommodations.text': "Grazie ai dati di Istat, Travel Appeal ed AirBnb il sito di IDD rende disponibili per la prima volta tutti i dati delle strutture ricettive in Italia: quelle di tipo alberghiero con classificazione a stelle, quelle extra-alberghiere (b&b, agriturismi, campeggi, villaggi, etc.) e gli appartamenti e alloggi atipici presenti solo online.",
        'guests_satisfaction.text': "Travel Appeal calcola la soddisfazione degli ospiti grazie a un motore semantico specializzato che legge ed elabora milioni di frasi in molteplici lingue. Quindi, un algoritmo intelligente - sensibile ai contesti, alle strutture sintattiche e alle connotazioni - attribuisce un valore all’esperienza raccontata dagli ospiti.",
        'tourist_source.text': "Chi visita l'Italia? In questa sezione sono raccolti i dati di Istat, Travel Appeal ed AirBnb sulla analisi dei principali mercati, per conoscere i trend degli arrivi turistici.",

        'regions.all': "Tutte le Regioni",
        'regions.aosta_valley': "Valle d'Aosta",
        'regions.piedmont': "Piemonte", 
        'regions.lombardy': "Lombardia", 
        'regions.veneto': "Veneto", 
        'regions.trentino_alto_adige': "Trentino Alto Adige", 
        'regions.friuli_venezia_giulia': "Friuli Venezia Giulia",
        'regions.liguria': "Liguria", 
        'regions.emilia_romagna': "Emilia Romagna", 
        'regions.tuscany': "Toscana", 
        'regions.marche': "Marche", 
        'regions.umbria': "Umbria", 
        'regions.lazio': "Lazio", 
        'regions.abruzzo': "Abruzzo", 
        'regions.molise': "Molise", 
        'regions.campania': "Campania", 
        'regions.apulia': "Puglia", 
        'regions.basilicata': "Basilicata", 
        'regions.calabria': "Calabria", 
        'regions.sicily': "Sicilia",
        'regions.sardinia': "Sardegna",

        'data_types.all': "Tutti i dati",
        'data_types.accommodations_in_italy': "Strutture ricettive in Italia",
        'data_types.total_accommodations': "Posti letto totali",
        'data_types.online_accommodations': "Strutture ricettive attive online",
        'data_types.online_apartments': "Annunci di appartamenti e alloggi atipici attivi online",
        'data_types.economics_per_inhabitant': "Attività economica per abitante",
        'data_types.accommodations_reviews': "Recensioni: strutture ricettive",
        'data_types.apartments_reviews': "Recensioni: appartamenti e alloggi atipici",
        'data_types.percent_accommodation_satisfaction': "Soddisfazione: strutture ricettive",
        'data_types.percent_apartment_satisfaction': "Soddisfazione: appartamenti e alloggi atipici",
        'data_types.percent_airbnb_5_stars_review': "% di recensioni a 5 stelle",
        'data_types.total_arrivals': "Arrivi totali",
        'data_types.percent_variance_arrivals': "Variazione degli arrivi",
        'data_types.total_reviews': "Recensioni totali",
        'data_types.total_attendances_airbnb': "Presenze",
        'data_types.percent_variance_arrivals_airbnb': "Variazione arrivi Airbnb",

        'sources.all': "Tutte le provenienze",
        'sources.italy': "Italia",
        'sources.united-states': "Stati Uniti",
        'sources.united-kingdom': "Gran Bretagna",
        'sources.france': "Francia",
        'sources.germany': "Germania"
    }
  }


// WEBPACK FOOTER //
// ./src/traslations/translations.js